module.exports = __webpack_public_path__ + "static/media/Horace Slughorn 3.8edd8ada.jpg";